/** @format */

import { GAME_VARIANT_LABEL_MAP } from "@/src/constants/StatsCornerConstants";
import styles from "../Stats.module.css";
import { formatINRCurrency, formatRank } from "@/Common/utils/statsUtil";
import { isA23 } from "../Stats";

const formatUnixDate = (ts) =>
  new Date(ts)
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "2-digit",
    })
    .replace(",", "")
    .replace(/(\d{2}) (\w{3}) (\d{2})/, "$1 $2 '$3");

export default function ScoreCard({ title, data }) {
  if (!data || data.length === 0) return null;
  return (
    <div className="mt-[24px]">
      <div className="text-base font-medium mb-3">{title}</div>
      {data.map((score, i) =>
        Object.keys(score).length > 0 ? (
          <div
            key={score.sno}
            className={`${i === data.length - 1 ? "" : "mb-3"} ${
              styles.statCard
            }`}
          >
            <div className="flex justify-between items-center">
              <div className="flex justify-start gap-2">
                <div
                  className={`${styles.variantLabel} text-center self-center`}
                >
                  {GAME_VARIANT_LABEL_MAP[score.gameVariant]?.shortLabel}
                </div>
                <div>{score.tournamentName}</div>
              </div>
              <div className="text-xs font-medium text-secondary items-center">
                {formatUnixDate(score.date)}
              </div>
            </div>
            <hr className={`${styles.tourneyScoreBorder} mt-1`} />
            <div className="flex justify-between text-center mt-4">
              <div>
                <div
                  className={`text-[14px] font-bold ${
                    isA23 ? "text-gold-primary" : "text-primary"
                  }`}
                >
                  {formatINRCurrency(score.winning)}
                </div>
                <div className="text-xs text-secondary">Winnings</div>
              </div>
              <div>
                <div className="text-[14px] font-bold">
                  {score.totalEntries}
                </div>
                <div className="text-xs text-secondary">Total Entries</div>
              </div>
              <div>
                <div className="text-[14px] font-bold">
                  {formatRank(score.rank)}
                </div>
                <div className="text-xs text-secondary">My Rank</div>
              </div>
            </div>
          </div>
        ) : null
      )}
    </div>
  );
}
